<template>
	<div class="shop-cat-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :gtype="0" />
		
		<div class="cat-layout animate__animated animate__fadeInUp">
			<!-- ====== 左侧：分类侧边栏（可展开/收起） ====== -->
			<div class="cat-sidebar">
				<!-- 一级 -->
				<div class="catItem" @click="cat1F(index,item)" v-for="(item,index) in catList">
					<div class="itemTitle f-ct" :class="cat1==index?'itemTitlea':''">
						<el-image class="i1" :src="require('@/static/add2/13.png')"></el-image>
						<div class="txtBox f-bct">
							<div class="txt">{{item.name}}</div>
							<el-image class="i2" :src="require('@/static/add2/10.png')"></el-image>
						</div>
					</div>
					<!-- 二级 -->
					<div class="catItem2List" :class="cat1==index?'catItem2List-a':''">
						<div class="catItem2-w" @click.stop="cat2F(idx,itm)" v-for="(itm,idx) in item.children">
							<div class="catItem2 f-ct" :class="cat2==idx?'catItem2-a':''">
								<el-image class="i1" :src="require('@/static/add2/11.png')"></el-image>
								<div class="txtBox f-bct">
									<div class="txt">{{itm.name}}</div>
									<!-- <el-image class="i2" :src="require('@/static/add2/10.png')"></el-image> -->
								</div>
							</div>
							<!-- 三级 -->
							<!-- <div class="catItem3List" :class="cat2==idx?'catItem3List-a':''">
								<div class="catItem3" :class="cat3==idxc?'catItem3-a':''" @click.stop="cat3F(idxc)" v-for="(itmc,idxc) in 3">短袖</div>
							</div> -->
						</div>
					</div>
				</div>
				
			</div>

			<!-- ====== 右侧：商品列表（参考shopIndex商品模块） ====== -->
			<div class="cat-products">
				<div class="products-toolbar">
					<el-image class="toolbar-check" :src="require('@/static/CodeBuddyAssets/30846_3480/17.svg')"></el-image>
					<span class="toolbar-label">{{selCat.name}}</span>
				</div>

				<div class="products-grid">
					<div class="product-card" @click="link('/shopMsg',{id:item.item_id,channelType:1})" v-for="(item, idx) in productList" :key="idx">
						<el-image class="product-img" :src="item.main_image_url" :preview-src-list="[item.main_image_url]" fit="cover"></el-image>
						<div class="product-name1 line2">
							<div class="product-tag tag-blue">自营</div>
							<!-- <div class="product-tag tag-red">1688</div> -->
							<!-- <div class="product-tag tag-orange">淘宝</div> -->
							<!-- <div class="product-tag tag-red">京东</div> -->
							{{ item.title }}
						</div>
						<div class="product-bottom">
							<span class="product-price">
								<span class="price-symbol">￥</span>
								<span class="price-value">{{ item.price }}</span>
							</span>
							<span class="product-sales">{{ item.salesCount }}人付款</span>
						</div>
					</div>
				</div>

				<!-- ====== 分页（复制自latestNews.vue） ====== -->
				<div v-if="productList.length" class="pagination-wrap animate__animated animate__fadeInUp">
					<el-pagination
						background
						layout="prev, pager, next, jumper"
						:total="total"
						:page-size="pageSize"
						:current-page.sync="currentPage"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import newsPageHeader from '@/components/newsPageHeader.vue'
import {
	goodsCategoryrecommendAndTree,
	goodslist,
} from "/src/api/api.js"
export default {
	name: 'ShopCat',
	components: {
		newsPageHeader
	},
	data() {
		return {
			currentPage: 1,
			pageSize: 12,
			total: 48,
			productList: [],
			// 分类
			catList:[],
			cat1:0,
			cat2:0,
			cat3:0,
			selCat:'',
		}
	},
	mounted() {
		this.loadCategory()
	},
	methods: {
		// 获取分类
		async loadCategory(){
			const res = await goodsCategoryrecommendAndTree({pid:0})
			if(res.code==200){
				var categoryList = res.data.categoryList||[]
				this.catList = []
				this.catList = this.catList.concat(categoryList)
				this.goodslistGet()
			}else{this.Tips(res.msg,'error')}
		},
		// 商品列表
		async goodslistGet(){
			var res;
			var data = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				channelType:1,
				keyword:this.searchKeyword,
			}
			var citm = this.catList[this.cat1]
			var children = citm.children||[]
			if(children.length){
				data.categoryId = children[this.cat2].id
			}
			res = await goodslist(data);
			if(res.code==200){
				this.total = res.total
				this.productList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 分页
		handleCurrentChange(page) {
			this.currentPage = page
			this.goodslistGet()
		},
		// 选择
		cat1F(index,item){
			this.cat1=index
			this.cat2=0
			this.cat3=0
			// 选择默认
			var children = item.children||[]
			if(children.length){
				this.selCat = children[0]
			}else{
				this.selCat = ''
			}
			this.goodslistGet()
		},
		cat2F(index,item){
			this.selCat = item
			this.cat2=index
			this.cat3=0
			this.goodslistGet()
		},
		cat3F(index){
			this.cat3=index
		},
	}
}
</script>

<style lang="scss" scoped>
.shop-cat-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

.cat-layout {
	width: 1128px;
	margin: 24px auto 0;
	display: flex;
}

/* ===================================================================
   左侧分类侧边栏
   =================================================================== */
.cat-sidebar {
	width: 239px;
	background: #fff;
	border-top-right-radius: 10px;
	box-sizing: border-box;
	min-height: 688px;
	.catItem{
		margin: 16px 0;
		margin-bottom: 4px;
		padding-right: 16px;
		cursor: pointer;
		.itemTitle{
			.i1{
				width: 2px;
				margin-right: 20px;
				opacity: 0;
			}
			.txtBox{
				flex: 1;
				.txt{
					font-size: 14px;
					color: #2C2C2C;
				}
				.i2{
					transition: 0.3s;
					width: 16px;
					transform: rotate(180deg);
					opacity: 0.6;
				}
			}
		}
		.itemTitlea{
			.i1{
				opacity: 1;
			}
			.txtBox{
				.txt{
					font-weight: bold;
				}
				.i2{
					transition: 0.3s;
					transform: rotate(0deg);
					opacity: 1;
				}
			}
		}
		.catItem2List{
			margin-top: 20px;
			max-height: 0;
			opacity: 0;
			overflow: hidden;
			transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1),
			            opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
			.catItem2{
				padding-left: 20px;
				margin-bottom: 20px;
				cursor: pointer;
				.i1{
					width: 4px;
					margin-right: 12px;
					opacity: 0.6;
					filter: grayscale(100%);
				}
				.txtBox{
					flex: 1;
					.txt{
						font-size: 14px;
						color: #999;
					}
					.i2{
						transition: 0.3s;
						width: 16px;
						transform: rotate(180deg);
						opacity: 0.6;
					}
				}
			}
			.catItem2-a{
				.i1{
					opacity: 1;
					filter: grayscale(0%);
				}
				.txtBox{
					.txt{
						font-weight: bold;
						color: #0096FF;
					}
					.i2{
						transition: 0.3s;
						transform: rotate(0deg);
						opacity: 1;
					}
				}
			}
			.catItem3List{
				padding-left: 40px;
				max-height: 0;
				opacity: 0;
				overflow: hidden;
				margin-top: -4px;
				transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
				            opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				.catItem3{
					font-size: 14px;
					color: #999999;
					cursor: pointer;
					margin-bottom: 16px;
				}
				.catItem3-a{
					font-size: 14px;
					color: #0096FF;
				}
			}
			.catItem3List-a{
				max-height: 300px;
				opacity: 1;
			}
		}
		.catItem2List-a{
			max-height: 500px;
			opacity: 1;
		}
		
	}
}


/* ===================================================================
   右侧商品区域（参考shopIndex商品模块）
   =================================================================== */
.cat-products {
	flex: 1;
	background: #fff;
	border-radius: 10px;
	margin-left: 24px;
	padding: 24px;
	box-sizing: border-box;
	min-height: 1012px;
}

.products-toolbar {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.toolbar-check {
	width: 2px;
	height: 12px;
	cursor: pointer;
	margin-right: 8px;
}
.toolbar-label {
	font-size: 16px;
	font-weight: 500;
	color: #333;
}

.products-grid {
	display: flex;
	flex-wrap: wrap;
}
.product-card {
	width: 186px;
	height: 280px;
	margin-right: 24px;
	margin-bottom: 24px;
	position: relative;
}
.product-card:nth-child(4n) {
	margin-right: 0;
}
.product-checkbox-area {
	position: absolute;
	top: 8px;
	left: 8px;
	z-index: 2;
	cursor: pointer;
}
.product-checkbox {
	width: 20px;
	height: 20px;
}

.product-img {
	width: 186px;
	height: 186px;
	border-radius: 10px;
	display: block;
	cursor: pointer;
}

.product-name1 {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-top: 12px;
	line-height: 24px;
	overflow: hidden;
	text-overflow: ellipsis;
	/* 参考 shopIndex 的 line2 样式 */
}
.line2 {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.product-tag {
	display: inline-block;
	border-radius: 4px;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
	padding: 0 4px;
	transform: translateY(-1px);
	line-height: normal;
}
.tag-orange {
	border: 1px solid #FF7120;
	background: #FFF5E9;
	color: #FF7120;
}
.tag-red {
	border: 1px solid #FC3C3C;
	background: #FFE9E9;
	color: #FC3C3C;
}
.tag-blue {
	border: 1px solid #0096FF;
	background: #E9F5FF;
	color: #0096FF;
}

.product-bottom {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 6px;
}
.product-price {
	color: #FC3C3C;
	display: inline-flex;
	align-items: baseline;
}
.price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.price-value {
	font-size: 18px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.product-sales {
	font-size: 12px;
	color: #999;
	font-weight: 400;
	text-align: right;
}

/* ===================================================================
   分页器（复制自latestNews.vue）
   =================================================================== */
.pagination-wrap {
	display: flex;
	justify-content: center;
	padding: 20px 0 10px;
	::v-deep .el-pagination {
		font-weight: 400;
		.el-pager li {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			border-radius: 4px;
			margin: 0 2px;
			color: #333;
			&.active {
				background: #0096FF;
				color: #fff;
				border-color: #0096FF;
			}
			&:hover {
				color: #0096FF;
			}
		}
		.el-pagination__total {
			font-size: 14px;
			color: #999;
			margin-right: 12px;
		}
		.btn-prev, .btn-next {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			border-radius: 4px;
			&:hover { color: #0096FF; }
		}
		.el-pagination__jump {
			font-size: 14px;
			color: #999;
			margin-left: 12px;
			.el-input__inner {
				width: 50px;
				height: 32px;
				line-height: 32px;
				font-size: 14px;
				border-radius: 4px;
				&:focus { border-color: #0096FF; }
			}
		}
	}
	::v-deep .el-pagination.is-background .el-pager li{
		background: transparent;
	}
	::v-deep .el-pagination.is-background .btn-prev{
		background: transparent;
	}
	::v-deep .el-pagination.is-background .btn-next{
		background: transparent;
	}
}
::v-deep .is-in-pagination{
	margin: 0 10px;
}
</style>
